import {PlatformCode} from '@dms/api/shared';

import type {VehicleMobileDePlatformAdvertisingAttribute} from './VehicleMobileDePlatformAdvertisingAttribute';

export type VehicleMobileDePlatformAdvertisingSettings = {
  platformCode: PlatformCode;
  enabled: boolean;
  attributes: Array<VehicleMobileDePlatformAdvertisingAttribute>;
  hasOverrides: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
};

export namespace VehicleMobileDePlatformAdvertisingSettings {
  export enum platformCode {
    MOBILE_DE = 'mobile.de',
  }
}
